import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    DashboardComparisonOptionView,
    GetOpportunityStatsByPeriodParameters,
    GetOpportunityStatsByPeriodResultOpportunityTotalsResultDto,
    OpportunityDashboardClient,
    OpportunityView
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class OpportunityDashboardService {
    constructor(private readonly client: OpportunityDashboardClient) {}

    async getNewProjects(): Promise<OpportunityView[]> {
        return await lastValueFrom(this.client.opportunityDashboardGetNewProjects());
    }

    async getUpcomingBids(): Promise<OpportunityView[]> {
        return await lastValueFrom(this.client.opportunityDashboardGetUpcomingBids());
    }

    async getComparisonOptions(): Promise<DashboardComparisonOptionView[]> {
        return await lastValueFrom(this.client.opportunityDashboardGetComparisonOptions());
    }

    async getOpportunityStats(
        comparisonId: number,
        divisionIds: number[] | undefined,
        salesPersonIds: number[] | undefined
    ): Promise<GetOpportunityStatsByPeriodResultOpportunityTotalsResultDto> {
        const body = {
            divisionIds: divisionIds,
            salesPersonIds: salesPersonIds
        } as GetOpportunityStatsByPeriodParameters;
        return await lastValueFrom(this.client.opportunityDashboardGetOpportunityStats(comparisonId, body));
    }
}
